import {
  BeakerIcon,
  BoxesIcon,
  ContainerIcon,
  GaugeIcon,
  LineChartIcon,
  type LucideIcon,
  MapPinHouseIcon,
  PackageIcon,
  ReceiptTextIcon,
  Settings2Icon,
  ShirtIcon,
  ShoppingBagIcon,
  StoreIcon,
  TruckIcon,
  ZapIcon,
} from 'lucide-react';

import { AccessContext } from '@invenco/common-interface/auth';

export type NavItem = {
  title: string;
  icon: LucideIcon;
  url?: string;
  children?: NavSubItem[];
  featureFlag?: string;
};

export type NavSubItem = {
  title: string;
  url: string;
};

export const ITEMS_BY_CONTEXT: Record<AccessContext, NavItem[]> = {
  SELLER: [
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: GaugeIcon,
    },
    {
      title: 'Products',
      url: '/products/skus',
      icon: ShirtIcon,
    },
    {
      title: 'Supply',
      url: '/supply/asns',
      icon: ContainerIcon,
    },
    {
      title: 'Inventory',
      url: '/inventory/quantities',
      icon: BoxesIcon,
    },
    {
      title: 'Sales',
      icon: ShoppingBagIcon,
      children: [
        { title: 'Orders', url: '/sales/orders' },
        { title: 'Listings', url: '/sales/listings' },
        { title: 'Channels', url: '/sales/channels' },
      ],
    },
    {
      title: 'Analytics',
      url: '/analytics/insights',
      icon: LineChartIcon,
    },
    {
      title: 'Automation',
      url: '/automation/workflows',
      icon: ZapIcon,
    },
    {
      title: 'Settings',
      url: '/settings',
      icon: Settings2Icon,
    },
  ],
  PLATFORM: [
    {
      title: 'Accounts',
      url: '/accounts',
      icon: StoreIcon,
    },
    {
      title: 'Locations',
      url: '/locations',
      icon: MapPinHouseIcon,
    },
    {
      title: 'Shipping',
      icon: TruckIcon,
      children: [
        { title: 'Carriers', url: '/shipping/carriers' },
        { title: 'Services', url: '/shipping/carrier-services' },
        { title: 'Prices', url: '/shipping/prices' },
        { title: 'Shipments', url: '/shipping/shipments' },
        { title: 'Quote', url: '/shipping/quote' },
      ],
    },
    {
      title: 'Bills',
      url: '/bills?view=PENDING',
      icon: ReceiptTextIcon,
    },
    {
      title: 'Simulations',
      url: '/simulations',
      icon: BeakerIcon,
      featureFlag: 'simulation-ui',
    },
  ],
  WAREHOUSE: [
    { title: 'Tenants', url: '/tenants', icon: StoreIcon },
    {
      title: 'Automation',
      url: '/automation/workflows',
      icon: ZapIcon,
    },
    {
      title: 'Carrier services',
      url: '/warehouse-carrier-services',
      icon: PackageIcon,
    },
  ],
  SYSTEM: [],
} as const;
